module.exports = __webpack_public_path__ + "img/snoskredaktsomhet.a6a01777.jpg";